import { VTab, VueTabs } from 'vue-nav-tabs'
import AdminDetailsTab from './details-tab/details-tab.vue'
import AdminAttendants from './attendants/attendants.vue'
import AdminApplicationAnswers from './application-answers/application-answers.vue'
import AdminSendEmail from './send-email/send-email.vue'
import AdminCourseMap from './course-map/course-map.vue'
import AdminCourseCoupons from './course-coupons/course-coupons.vue'
import store from '@/services/store.js';

export default {
    name: 'AdminCourseDetails',
    components: {
        VueTabs,
        VTab,
        AdminDetailsTab,
        AdminAttendants,
        AdminApplicationAnswers,
        AdminSendEmail,
        AdminCourseMap,
        AdminCourseCoupons
    },
    computed: {
        courseId() {
            return this.$route.params.id;
        },
        courseIdValue() {
            return store.getters.getCourseId;
        },
        courseNameValue() {
            return store.getters.getCourseName;
        }
    },
    data() {
        return {

        }
    },
    methods: {
        backToCourses() {
            this.$router.push({ path: "/admin/courses" });
        },
        showMap(tabIndex, to, from) {
            if (to.title === "Location") {
                this.$refs.gmap.showMap();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/courses/course-details/course-details.js